import { Button as MUIButton, CircularProgress } from "@mui/material";
import clsx from "clsx";
import { useCallback, useEffect } from "react";
import tw, { styled } from "twin.macro";
import ArrowBack from "./assets/svgs/ArrowBack";
import Wallet from "./components/Wallet";
import useConnector from "./lib/hooks/useConnector";
import * as ga from "@app/lib/analytics";

const analyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

const Button = styled(MUIButton)`
  ${tw`text-xs md:text-base`}
`;

function App() {
  const { authorized, disconnect, loading, connect } = useConnector();

  useEffect(() => {
    if (analyticsId) {
      ga.pageview?.(window.location.pathname + window.location.search);
    }
  }, []);

  const renderContent = useCallback(() => {
    if (loading) {
      return (
        <div className="p-6 flex items-center justify-center">
          <CircularProgress />
        </div>
      );
    }
    if (!authorized) {
      return (
        <div className="flex flex-col p-4 bg-gray-100 space-y-4">
          <div>
            <div className="font-bold text-lg">Welcome to MTVX Dashboard!</div>
            <div className="text-[#333333]">Check your balance, rewards &amp; claim right from MTVX Dashboard!</div>
          </div>
          <div className="space-y-2">
            <div className="text-[#555555]">Please connect your wallet to continue</div>
            <div className="flex items-center space-x-2">
              <Button
                variant="contained"
                color="primary"
                type="button"
                size="large"
                fullWidth
                onClick={connect}
                className="px-3 py-2 rounded font-medium text-xs md:text-base"
              >
                Connect Wallet
              </Button>
            </div>
          </div>

          <a
            href="https://mtvx.io"
            className="flex items-center rounded self-start border border-primary p-2 space-x-2 text-primary hover:text-white transition-color duration-300 hover:bg-primary"
          >
            <ArrowBack className="w-6 h-6" />
            <span>Back to mtvx.io</span>
          </a>
        </div>
      );
    }
    return <Wallet />;
  }, [authorized, connect, loading]);

  return (
    <div className="w-full md:min-h-screen relative">
      <img src="/images/hero-bg.png" className="absolute w-full h-full object-cover left-0 top-0" alt="hero-bg" />
      <div className="h-full md:min-h-screen w-full flex items-center justify-center">
        <div className="flex flex-col space-y-6 pt-4 md:pt-0 w-full items-center">
          <img src="/images/mtvx-hero.svg" alt="MTVX" className="h-[180px] z-20" />
          <div className="flex flex-col bg-white w-full md:max-w-[520px] md:rounded overflow-hidden shadow-md z-10">
            <div
              className={clsx("p-4 flex items-center border-b border-[#e2e2e2]", {
                "justify-center": !authorized,
                "justify-between": authorized,
              })}
            >
              <img src="/images/dashboard-icon.svg" alt="MTVX Dashboard" className="h-6" />
              {authorized && (
                <div className="flex items-center space-x-2">
                  <Button
                    variant="outline"
                    color="secondary"
                    type="button"
                    onClick={disconnect}
                    className="px-3 py-2 rounded font-medium text-xs md:text-base"
                  >
                    Logout
                  </Button>
                </div>
                // <div className="px-3 py-1 rounded font-medium text-xs bg-yellow-100 border-2 border-secondary">
                //   <div className="text-[10px]">Connected Address</div>
                //   <div>
                //     {account?.substr(0, 8)}*****{account?.substr(account?.length - 4, 4)}
                //   </div>
                // </div>
              )}
            </div>
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
